import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import cx from "classnames";

const InputS1 = ({
                     className,
                     inputClassName,
                     label,
                     readOnly,
                     placeholder,
                     type,
                     size,
                     field,
                     disabled,
                     isRequired,
                     validate,
					 prependData,
					 autoFocus,
                     form: {touched, errors},
                     ...props
                 }) => {

    const {t} = useTranslation("main");
    const classes = cx(
        'form-field',
        touched[field.name] && errors[field.name] && 'form-field--error',
        `form-field--${size}`,
        disabled && `form-field--disabled`,
        field.value && 'form-field--active',
        className
    );

    return (
        <div className={classes}>
            {label && (
                <label className="form-field__label">
                    {label}
                    {isRequired && <span title={"Обязательный поля"}>*</span>}
                </label>
            )}
            <div className="input-group">
                <input
                    className={cx("form-field__input", inputClassName)}
					autoComplete="off"
                    readOnly={readOnly}
                    disabled={disabled}
					autoFocus={autoFocus}
                    {...{placeholder, type}}
                    {...field}
                    {...props}
                />

				{prependData && prependData}

                {touched[field.name] && errors[field.name] && (
                    <div className="form-field__error">
                        <span>{t(errors[field.name])}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

InputS1.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(["text", "password", "number"]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    size: PropTypes.oneOf(["default", "large", "small"]),
    disabled: PropTypes.bool,
    isRequired: PropTypes.bool,
};

InputS1.defaultProps = {
    label: "",
    placeholder: "",
    type: "text",
    className: null,
    readOnly: false,
    disabled: false,
    isRequired: false,
    size: "default",
};

export default InputS1;
